import moment from 'moment-timezone';

export default function momentIsSame(datetime1, datetime2) {
  return moment(datetime1).isSame(moment(datetime2));
}
